import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

import { getAuthClient, getToken } from '@verantos-dev/core-auth';

const getBaseApiUrl = (): string => import.meta.env.VITE_BASE_API_URL;

const BASE_API_URL = getBaseApiUrl();
type BaseApiOptions = {
  version?: string;
  overrideBaseUrl?: string;
};

let redirectInProgress = false;

/** @internal Reset redirect state — only for testing */
export const _resetRedirectState = () => {
  redirectInProgress = false;
};

export const createBaseQuery = ({
  version = 'v1',
  overrideBaseUrl = BASE_API_URL,
}: BaseApiOptions): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  const baseQuery = fetchBaseQuery({
    baseUrl: `${overrideBaseUrl}/${version}`,
    prepareHeaders: async (headers) => {
      const token = await getToken();
      headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  });

  return async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
      // Notify AuthProvider to immediately hide children (prevents error UI flash)
      window.dispatchEvent(new CustomEvent('auth-invalidated'));

      if (!redirectInProgress) {
        redirectInProgress = true;
        console.info('Received 401 response, redirecting to login');
        const auth0Client = await getAuthClient();
        auth0Client.loginWithRedirect();
      }
    }

    return result;
  };
};
